// test1027
(1027 && 0);
